// Components
import Button from 'components/General/Button/Button';

// Logic
import { useLogic } from '../Payment.logic';

export const Apple = () => {
  const { dispatch, setChosePaymentMethod } = useLogic();

  return (
    <div className="apple-container">
      <h1>Apple</h1>
      <Button
        color="primary"
        onClick={() => dispatch(setChosePaymentMethod(false))}
      >
        Back to payment
      </Button>
    </div>
  );
};
